import CardReview from "components/CardReview";
import React from "react";
import PP from 'assets/images/pp.png'
import Slider from "react-slick";
import SecondaryButton from "components/SecondaryButton";
import { useNavigate } from "react-router-dom";

export default function Review() {
  const navigate = useNavigate();
   const settings = {
     dots: true,
     infinite: true,
     speed: 500,
     slidesToShow: 2,
     slidesToScroll: 2,
     adaptiveHeight: true,
     centerPadding: 100,
     dotsClass: "button__bar",
     responsive: [
       {
         breakpoint: 1024,
         settings: {
           slidesToShow: 2,
           slidesToScroll: 2,
           dots: true,
         },
       },
       {
         breakpoint: 600,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           initialSlide: 1,
         },
       },
       {
         breakpoint: 480,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
         },
       },
     ],
   };
  return (
    <div className="relative px-5 pb-32 space-y-16 bg-transparent wrapper xl:px-99">
      <h1 className="text-3xl font-bold text-center">
        Apa kata perangkat desa?
      </h1>
      <Slider {...settings}>
        {/* <div className="gap-20 space-y-8 md:space-y-0 md:grid-cols-2 md:grid cardWrapper mt-11"> */}
        <CardReview
          name="Ariq Zuhdi"
          logo={PP}
          jabatan="Kepala Desa Suban Ayam"
        />
        <CardReview
          name="Ariq Zuhdi"
          logo={PP}
          jabatan="Kepala Desa Suban Ayam"
        />
        <CardReview
          name="Ariq Zuhdi"
          logo={PP}
          jabatan="Kepala Desa Suban Ayam"
        />
        <CardReview
          name="Ariq Zuhdi"
          logo={PP}
          jabatan="Kepala Desa Suban Ayam"
        />
        {/* </div> */}
      </Slider>
      <h1 className="mt-16 text-3xl font-bold text-center">
        Saatnya desa kamu menjadi Geulanggang-Panah
      </h1>
      <div className="flex justify-center">
        <SecondaryButton label="Daftarkan Desamu" onClick={()=> navigate('/register')} />
      </div>
    </div>
  );
}
